export enum NOTIFICATION_EVENT {
  CONNECT_ERROR = 'connect_error',
  CONNECT = 'connect',
  NOTIFICATION = 'notification',
  UNAUTHORIZED = 'unauthorized',


}
